import React from 'react';
import i18next from "../../i18n";
import { formFieldTypes } from '../../constants';

const MonthInput = (props) => {
    if (!props.value && props.onChange) {
        props.onChange({
            target: {
                value: "01",
                name: props.name,
                type: formFieldTypes.month,
                getAttribute: () => { }
            }
        });
    }

    return <select name={props.name} className="form-control" value={props.value} onChange={props.onChange} disabled={props.disabled ? "disabled" : ""}>
        {Array.from({ length: 12 }, (_, index) => index).map(index => <option key={index} value={`0${index + 1}`.slice(-2)} style={{ display: props.hidden ? "none" : "" }}>{i18next.t(`months.${index}`)}</option>)
        }
    </select>
}

export default MonthInput;